function kiddlaIdle(callback){
  if('requestIdleCallback' in window){ requestIdleCallback(callback,{timeout:1800}); }
  else { setTimeout(callback, 700); }
}

function kiddlaFormatMoney(cents){
  var n = Number(cents || 0);
  var amount = (n / 100).toFixed(2);
  var format = window.KiddlaMoneyFormat || '${{amount}}';
  var raw = format
    .replace(/\{\{\s*amount\s*\}\}/, amount)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n / 100));
  var code = window.KiddlaCurrencyCode || 'USD';
  var clean = String(raw)
    .replace(/CAD/g, '')
    .replace(/CA\$/g, '$')
    .replace(/USD/g, '')
    .replace(/US\$/g, '$')
    .replace(/GBP/g, '')
    .trim();
  if(code === 'CAD') return 'CAD' + clean;
  if(code === 'AUD') return 'AUD' + clean;
  if(code === 'GBP') return clean.indexOf('£') !== -1 ? clean : 'GBP ' + clean;
  return clean;
}
window.KiddlaFormatMoney = kiddlaFormatMoney;

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-menu-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var nav = document.querySelector('[data-mobile-nav]');
      if(nav) nav.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var wrap = btn.closest('[data-gallery]');
      if(!wrap) return;
      var main = wrap.querySelector('[data-gallery-main]');
      if(main){
        if(btn.dataset.srcset){
          main.setAttribute('srcset', btn.dataset.srcset);
          main.setAttribute('sizes', '(max-width: 749px) calc(100vw - 32px), (max-width: 1199px) 54vw, 680px');
        } else {
          main.removeAttribute('srcset');
        }
        main.src = btn.dataset.full;
        main.alt = btn.dataset.alt || '';
        if(btn.dataset.mediaId) main.dataset.currentMediaId = btn.dataset.mediaId;
      }
      wrap.querySelectorAll('[data-gallery-thumb]').forEach(function(b){b.classList.remove('is-active')});
      btn.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-qty]').forEach(function(box){
    var input = box.querySelector('input');
    box.querySelectorAll('[data-qty-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var value = parseInt(input.value || '1', 10);
        if(btn.dataset.qtyBtn === 'plus') value += 1;
        if(btn.dataset.qtyBtn === 'minus') value = Math.max(1, value - 1);
        input.value = value;
      });
    });
  });

  var form = document.querySelector('[data-product-form]');
  if(form){
    var variantsEl = form.querySelector('[data-variants-json]');
    var mediaEl = form.querySelector('[data-variant-media-json]');
    var variants = [];
    var variantMedia = {};
    if(variantsEl){
      try{ variants = JSON.parse(variantsEl.textContent); }catch(e){}
    }
    if(mediaEl){
      try{ variantMedia = JSON.parse(mediaEl.textContent); }catch(e){}
    }
    function money(cents){
      return window.KiddlaFormatMoney ? window.KiddlaFormatMoney(cents) : kiddlaFormatMoney(cents);
    }
    function selectedOptions(){
      var values = [];
      var groups = form.querySelectorAll('[data-option-index]');
      var map = {};
      groups.forEach(function(el){
        var idx = el.dataset.optionIndex;
        if(el.type === 'radio' && el.checked) map[idx] = el.value;
        if(el.tagName === 'SELECT') map[idx] = el.value;
      });
      Object.keys(map).sort().forEach(function(k){ values.push(map[k]); });
      return values;
    }
    function syncOptionLabels(){
      form.querySelectorAll('.k-option-group').forEach(function(group){
        var label = group.querySelector('.k-option-label');
        var selected = group.querySelector('input[data-option-index]:checked') || group.querySelector('select[data-option-index]');
        if(!label || !selected) return;
        var original = label.textContent.split(' - ')[0].trim();
        if(/^colou?r$/i.test(original)) label.textContent = original + ' - ' + selected.value;
      });
    }
    function switchGalleryToVariant(variant){
      var productMain = form.closest('.k-product-main');
      if(!productMain || !variant) return;
      var info = variantMedia[String(variant.id)] || {};
      var src = info.src;
      var mediaId = info.media_id || info.image_id;
      if(!src && variant.featured_image && variant.featured_image.src) src = variant.featured_image.src;
      if(!src && !mediaId) return;
      var gallery = productMain.querySelector('[data-gallery]');
      if(!gallery) return;
      var main = gallery.querySelector('[data-gallery-main]');
      var targetThumb = null;
      if(mediaId){
        targetThumb = gallery.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
      }
      if(!targetThumb && src){
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb){
          if(!targetThumb && thumb.dataset.full && thumb.dataset.full.indexOf(src.split('?')[0]) !== -1) targetThumb = thumb;
        });
      }
      if(targetThumb){
        targetThumb.click();
        try{ targetThumb.scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'}); }catch(e){}
        return;
      }
      if(main && src){
        main.removeAttribute('srcset');
        main.src = src;
        main.alt = info.alt || main.alt || '';
        if(mediaId) main.dataset.currentMediaId = mediaId;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(b){b.classList.remove('is-active')});
      }
    }
    function updateVariant(){
      if(!variants.length) return;
      var opts = selectedOptions();
      var variant = variants.find(function(v){
        return opts.every(function(opt, i){ return v.options[i] === opt; });
      });
      if(!variant) return;
      var idInput = form.querySelector('input[name="id"]');
      if(idInput) idInput.value = variant.id;
      var price = document.querySelector('[data-product-price]');
      var compare = document.querySelector('[data-product-compare]');
      var atc = form.querySelector('[data-atc]');
      if(price) price.textContent = money(variant.price);
      if(compare){ compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''; }
      if(atc){ atc.disabled = !variant.available; atc.textContent = variant.available ? 'ADD TO CART' : 'Sold out'; }
      syncOptionLabels();
      switchGalleryToVariant(variant);
    }
    form.querySelectorAll('[data-option-index]').forEach(function(el){ el.addEventListener('change', updateVariant); });
  }
});

// Kiddla v14 fallback country selector memory for stores without Shopify Markets country form
kiddlaIdle(function(){
  var selects = document.querySelectorAll('[data-country-select]');
  if(!selects.length) return;
  var saved = null;
  try { saved = localStorage.getItem('kiddla_country'); } catch(e) {}
  selects.forEach(function(select){
    if(saved) select.value = saved;
    select.addEventListener('change', function(){
      try { localStorage.setItem('kiddla_country', select.value); } catch(e) {}
    });
  });
});

// Kiddla v55: auto-select Shopify Market country using Shopify's browsing context suggestion.
// This submits Shopify's localization form once per session for US / CA / GB / AU, then all prices and shipping messages are rendered by the selected market.
kiddlaIdle(function(){
  try{
    if(document.body && document.body.classList.contains('k-design-mode')) return;
    if(!window.KiddlaAutoGeoCountry) return;
    if(sessionStorage.getItem('kiddla_geo_market_checked') === '1') return;
    sessionStorage.setItem('kiddla_geo_market_checked','1');
    var manualUntil = Number(localStorage.getItem('kiddla_manual_country_until') || 0);
    if(manualUntil && Date.now() < manualUntil) return;
    var form = document.querySelector('form[action*="/localization"], form[action$="/localization"], form[id*="CountryForm"]');
    var select = form && form.querySelector('select[name="country_code"]');
    if(!form || !select) return;
    fetch('/browsing_context_suggestions.json?source=geolocation_recommendations&locale=en', {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(data){
        if(!data) return;
        var country = data.detected_values && data.detected_values.country;
        var code = country && (country.handle || country.iso_code || country.country_code || country.code);
        code = String(code || '').toUpperCase();
        if(code === 'UK') code = 'GB';
        if(['US','CA','GB','AU'].indexOf(code) === -1) return;
        var hasOption = Array.prototype.some.call(select.options, function(option){ return option.value === code; });
        if(!hasOption || select.value === code) return;
        select.value = code;
        form.submit();
      })
      .catch(function(){});
  }catch(e){}
});

document.addEventListener('change', function(event){
  var select = event.target && event.target.matches && event.target.matches('select[name="country_code"]') ? event.target : null;
  if(!select) return;
  try{ localStorage.setItem('kiddla_manual_country_until', String(Date.now() + 7*24*60*60*1000)); }catch(e){}
}, true);

// Kiddla v17 dropdown navigation: click to open, click outside to close.
kiddlaIdle(function(){
  var dropdowns = document.querySelectorAll('[data-nav-dropdown]');
  dropdowns.forEach(function(dropdown){
    var toggle = dropdown.querySelector('[data-dropdown-toggle]');
    if(!toggle) return;
    toggle.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      var isOpen = dropdown.classList.contains('is-open');
      dropdowns.forEach(function(item){
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-dropdown-toggle]');
        if(btn) btn.setAttribute('aria-expanded','false');
      });
      if(!isOpen){
        dropdown.classList.add('is-open');
        toggle.setAttribute('aria-expanded','true');
      }
    });
  });
  document.addEventListener('click', function(){
    dropdowns.forEach(function(item){
      item.classList.remove('is-open');
      var btn = item.querySelector('[data-dropdown-toggle]');
      if(btn) btn.setAttribute('aria-expanded','false');
    });
  });
});

// Kiddla v22: Customer Reviews carousel.
// In Shopify theme editor, we deliberately keep reviews as a static grid to prevent editor preview reload errors while editing blocks.
(function(){
  function isDesignMode(){
    return document.body && document.body.classList.contains('k-design-mode');
  }

  function initReviewSlider(root){
    if(isDesignMode()) return;
    var scope = root || document;
    scope.querySelectorAll('[data-review-slider]').forEach(function(slider){
      if(slider.dataset.kiddlaSliderReady === 'true') return;
      slider.dataset.kiddlaSliderReady = 'true';
      var track = slider.querySelector('[data-review-track]');
      var prev = slider.querySelector('[data-review-prev]');
      var next = slider.querySelector('[data-review-next]');
      if(!track || !prev || !next) return;

      function cardStep(){
        var card = track.querySelector('.k-review-card');
        if(!card) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons(){
        var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= max;
        prev.classList.toggle('is-disabled', atStart);
        next.classList.toggle('is-disabled', atEnd);
        prev.disabled = atStart;
        next.disabled = atEnd;
        var canScroll = track.scrollWidth > track.clientWidth + 4;
        prev.style.display = canScroll ? '' : 'none';
        next.style.display = canScroll ? '' : 'none';
      }

      prev.addEventListener('click', function(event){ event.preventDefault(); track.scrollBy({left:-cardStep(), behavior:'smooth'}); });
      next.addEventListener('click', function(event){ event.preventDefault(); track.scrollBy({left:cardStep(), behavior:'smooth'}); });
      track.addEventListener('scroll', function(){ window.requestAnimationFrame(updateButtons); }, {passive:true});
      window.addEventListener('resize', updateButtons, {passive:true});
      setTimeout(updateButtons, 100);
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ kiddlaIdle(function(){ initReviewSlider(document); }); });
  document.addEventListener('shopify:section:load', function(event){ initReviewSlider(event.target); });
  document.addEventListener('shopify:block:select', function(event){
    var card = event.target && event.target.closest ? event.target.closest('.k-review-card') : null;
    if(card){
      try{ card.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'}); }catch(e){}
    }
  });
})();


// Kiddla v29: Ajax cart drawer (right-side Toddla-style drawer, no payment badges).
(function(){
  function formatMoney(cents){
    return window.KiddlaFormatMoney ? window.KiddlaFormatMoney(cents) : kiddlaFormatMoney(cents);
  }
  function escapeHtml(value){
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(s){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[s]; });
  }
  function routes(){ return window.KiddlaRoutes || {}; }
  function rootRoute(){
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || routes().root || '/';
    root = String(root || '/');
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }
  function toAjaxUrl(route, fallback){
    route = String(route || fallback || '');
    if(!route) return fallback || '';
    route = route.replace(/\?.*$/, '');
    if(route.indexOf('.js') !== -1 || route.indexOf('.json') !== -1) return route;
    return route.replace(/\/?$/, '') + '.js';
  }
  function uniqueUrls(list){
    var out = [];
    list.forEach(function(url){
      if(!url) return;
      if(out.indexOf(url) === -1) out.push(url);
    });
    return out;
  }
  function cartJsonUrls(kind){
    var r = routes();
    var root = rootRoute();
    if(kind === 'add') return uniqueUrls([toAjaxUrl(r.cartAdd), root + 'cart/add.js', '/cart/add.js']);
    if(kind === 'change') return uniqueUrls([toAjaxUrl(r.cartChange), root + 'cart/change.js', '/cart/change.js']);
    return uniqueUrls([toAjaxUrl(r.cart), root + 'cart.js', '/cart.js']);
  }
  function fetchJsonFallback(urls, options){
    urls = uniqueUrls(urls || []);
    var index = 0;
    function next(){
      var url = urls[index++];
      if(!url) return Promise.reject(new Error('No available cart endpoint'));
      return fetch(url, options || {credentials:'same-origin', headers:{'Accept':'application/json'}})
        .then(function(res){ if(!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .catch(function(error){ if(index < urls.length) return next(); throw error; });
    }
    return next();
  }
  function setNotice(message){
    var el = drawer();
    var notice = el && el.querySelector('[data-cart-drawer-notice]');
    if(!notice) return;
    if(message){ notice.textContent = message; notice.hidden = false; }
    else { notice.hidden = true; notice.textContent = ''; }
  }
  var judgeMeBadgeCache = window.KiddlaJudgeMeBadgeCache = window.KiddlaJudgeMeBadgeCache || {};
  var judgeMeBadgeFetches = {};
  function hasJudgeMeBadge(node){
    return !!(node && node.querySelector && node.querySelector('.jdgm-prev-badge, .jdgm-star, .jdgm-widget'));
  }
  function cacheJudgeMeBadges(root){
    root = root || document;
    try{
      root.querySelectorAll('[data-id].jdgm-preview-badge, .product-card__judgeme[data-id], .k-judgeme-badge[data-id], .k-cart-judgeme-mini[data-id]').forEach(function(node){
        var id = node.getAttribute('data-id');
        if(!id) return;
        var html = (node.innerHTML || '').trim();
        if(html && (html.indexOf('jdgm-prev-badge') !== -1 || html.indexOf('jdgm-star') !== -1)){
          judgeMeBadgeCache[String(id)] = html;
        }
      });
    }catch(e){}
  }
  function productHandleFromUrl(url){
    if(!url) return '';
    var match = String(url).match(/\/products\/([^?/#]+)/);
    return match ? match[1] : '';
  }
  function fetchJudgeMeBadge(productId, handle){
    productId = String(productId || '');
    if(!productId || judgeMeBadgeCache[productId]) return Promise.resolve(judgeMeBadgeCache[productId] || '');
    if(!handle) return Promise.resolve('');
    if(judgeMeBadgeFetches[productId]) return judgeMeBadgeFetches[productId];
    judgeMeBadgeFetches[productId] = fetch(rootRoute() + 'products/' + encodeURIComponent(handle) + '?section_id=main-product', {credentials:'same-origin', headers:{'Accept':'text/html'}})
      .then(function(res){ return res.ok ? res.text() : ''; })
      .then(function(html){
        if(!html) return '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        cacheJudgeMeBadges(doc);
        var node = doc.querySelector('.k-judgeme-badge[data-id="' + productId + '"], .jdgm-preview-badge[data-id="' + productId + '"]');
        var out = node ? (node.innerHTML || '').trim() : '';
        if(out && (out.indexOf('jdgm-prev-badge') !== -1 || out.indexOf('jdgm-star') !== -1)){
          judgeMeBadgeCache[productId] = out;
          return out;
        }
        return judgeMeBadgeCache[productId] || '';
      })
      .catch(function(){ return ''; });
    return judgeMeBadgeFetches[productId];
  }
  function hydrateCartJudgeMeBadges(root){
    root = root || document;
    cacheJudgeMeBadges(document);
    var badges = root.querySelectorAll('.k-cart-judgeme-mini[data-id]');
    badges.forEach(function(badge){
      var productId = String(badge.getAttribute('data-id') || '');
      var handle = badge.getAttribute('data-product-handle') || '';
      var cached = productId ? judgeMeBadgeCache[productId] : '';
      if(cached && !hasJudgeMeBadge(badge)){
        badge.innerHTML = cached;
      }
      if(!hasJudgeMeBadge(badge) && productId && handle){
        fetchJudgeMeBadge(productId, handle).then(function(html){
          if(html && !hasJudgeMeBadge(badge)){
            badge.innerHTML = html;
            if(window.KiddlaRefreshJudgeMeBadges) window.KiddlaRefreshJudgeMeBadges(root);
          }
        });
      }
    });
  }
  function resizeShopifyImage(url, size){
    if(!url || typeof url !== 'string') return '';
    if(url.indexOf('_' + size) !== -1) return url;
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + '$1$3');
  }
  function productImageUrl(product, size){
    if(!product) return '';
    var img = product.featured_image || (product.images && product.images[0]);
    if(img && typeof img === 'object') img = img.src || img.url || img.originalSrc || '';
    return resizeShopifyImage(img || '', size || '160x');
  }
  function refreshJudgeMe(root){
    root = root || document;
    hydrateCartJudgeMeBadges(root);
    try {
      if(window.jdgm && typeof window.jdgm.renderBadges === 'function') window.jdgm.renderBadges();
      if(window.jdgm && typeof window.jdgm.loadBadges === 'function') window.jdgm.loadBadges();
      if(window.jdgm && typeof window.jdgm.init === 'function') window.jdgm.init();
      if(window.JDGM && typeof window.JDGM.refresh === 'function') window.JDGM.refresh();
    } catch(e){}
    hydrateCartJudgeMeBadges(root);
    if(window.KiddlaRefreshJudgeMeBadges) window.KiddlaRefreshJudgeMeBadges(root);
    [250, 700, 1400, 2600].forEach(function(delay){ setTimeout(function(){ hydrateCartJudgeMeBadges(root); if(window.KiddlaRefreshJudgeMeBadges) window.KiddlaRefreshJudgeMeBadges(root); }, delay); });
  }
  function judgeMeMini(productId, title, handle){
    if(!productId) return '';
    var cached = judgeMeBadgeCache[String(productId)] || '';
    return '<div class="k-cart-judgeme-mini jdgm-widget jdgm-preview-badge" data-id="' + productId + '" data-product-handle="' + escapeHtml(handle || '') + '" data-product-title="' + escapeHtml(title || '') + '" aria-label="Product rating">' + cached + '</div>';
  }
  function drawer(){ return document.querySelector('[data-cart-drawer]'); }
  function openDrawer(){
    var el = drawer(); if(!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden','false');
    document.body.classList.add('k-cart-drawer-open');
    var panel = el.querySelector('.k-cart-drawer__panel');
    if(panel) setTimeout(function(){ try{ panel.focus(); }catch(e){} }, 40);
  }
  function closeDrawer(){
    var el = drawer(); if(!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden','true');
    document.body.classList.remove('k-cart-drawer-open');
  }
  function setLoading(isLoading){ var el = drawer(); if(el) el.classList.toggle('is-loading', !!isLoading); }
  function updateHeaderCount(count){
    document.querySelectorAll('[data-cart-count-badge]').forEach(function(badge){
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-count]').forEach(function(node){ node.textContent = count; });
  }
  function renderCart(cart){
    var el = drawer(); if(!el || !cart) return;
    var threshold = parseInt(el.getAttribute('data-free-shipping-threshold') || '7900', 10);
    var amountLeft = Math.max(0, threshold - cart.total_price);
    var progress = threshold > 0 ? Math.min(100, Math.round(cart.total_price * 100 / threshold)) : 100;
    var progressText = el.querySelector('[data-cart-progress-text]');
    if(progressText){
      progressText.innerHTML = amountLeft > 0 ? 'Add <strong>' + formatMoney(amountLeft) + '</strong> more to unlock <strong>Free Shipping</strong>' : 'You got <strong>Free Shipping!</strong>';
    }
    var progressBar = el.querySelector('[data-cart-progress-bar]');
    if(progressBar) progressBar.style.width = progress + '%';
    var itemsWrap = el.querySelector('[data-cart-items]');
    if(itemsWrap){
      if(!cart.items.length){
        itemsWrap.innerHTML = '<div class="k-cart-drawer__empty" data-cart-empty><h3>Your cart is empty</h3><p>Pick a playful Kiddla toy and come back here when you’re ready.</p><a class="k-btn" href="' + rootRoute() + 'collections/all">Shop now</a></div>';
      } else {
        itemsWrap.innerHTML = cart.items.map(function(item, index){
          var line = index + 1;
          var image = item.image ? '<img src="' + item.image.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_180x$1') + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">' : '<span>🧸</span>';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="k-drawer-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
          var compare = item.original_line_price > item.final_line_price ? '<span class="k-drawer-item__compare">' + formatMoney(item.original_line_price) + '</span>' : '';
          var save = item.original_line_price > item.final_line_price ? '<span class="k-drawer-item__save">Save ' + formatMoney(item.original_line_price - item.final_line_price) + '</span>' : '';
          return '<article class="k-drawer-item" data-cart-line="' + line + '">' +
            '<a class="k-drawer-item__image" href="' + item.url + '">' + image + '</a>' +
            '<div class="k-drawer-item__content"><div class="k-drawer-item__top">' +
            '<a class="k-drawer-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
            '<button class="k-drawer-item__remove" type="button" data-cart-change data-line="' + line + '" data-quantity="0" aria-label="Remove ' + escapeHtml(item.product_title) + '"><svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path d="M6 7h12M10 11v6M14 11v6M9 7l1-2h4l1 2M8 7l1 13h6l1-13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
            '</div>' + variant + '<div class="k-drawer-item__price">' + compare + '<strong>' + formatMoney(item.final_line_price) + '</strong>' + save + '</div>' +
            '<div class="k-drawer-item__rating">' + judgeMeMini(item.product_id, item.product_title, item.handle || productHandleFromUrl(item.url)) + '</div>' +
            '<div class="k-drawer-item__qty" aria-label="Quantity"><button type="button" data-cart-change data-line="' + line + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-cart-change data-line="' + line + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
            '</div></article>';
        }).join('');
      }
    }
    var subtotal = el.querySelector('[data-cart-subtotal]'); if(subtotal) subtotal.textContent = formatMoney(cart.total_price);
    var checkoutTotal = el.querySelector('[data-cart-checkout-total]'); if(checkoutTotal) checkoutTotal.textContent = formatMoney(cart.total_price);
    updateHeaderCount(cart.item_count || 0);
    renderSmartUpsells(cart);
    refreshJudgeMe(el);
  }

  function renderUpsellProducts(products, cart){
    var el = drawer(); if(!el) return;
    var wrap = el.querySelector('[data-cart-smart-upsell]');
    var list = el.querySelector('[data-cart-upsell-list]');
    if(!wrap || !list) return;
    var cartProductIds = {};
    (cart.items || []).forEach(function(item){ cartProductIds[String(item.product_id)] = true; });
    var seen = {};
    var html = [];
    (products || []).forEach(function(product){
      if(!product || cartProductIds[String(product.id)] || seen[String(product.id)] || html.length >= 4) return;
      seen[String(product.id)] = true;
      if(product.available === false) return;
      var variant = (product.variants || []).find(function(v){ return v && v.available !== false; }) || (product.variants || [])[0] || {};
      var variantId = product.first_available_variant_id || variant.id;
      if(!variantId) return;
      var img = productImageUrl(product, '160x');
      var image = img ? '<img src="' + img + '" alt="' + escapeHtml(product.title) + '" width="70" height="70" loading="lazy">' : '';
      var price = typeof product.price === 'number' ? formatMoney(product.price) : (product.price || '');
      var url = product.url || (rootRoute() + 'products/' + product.handle);
      html.push('<article class="k-drawer-upsell-card" data-smart-product-id="' + product.id + '">' +
        '<a class="k-drawer-upsell-card__image" href="' + url + '">' + image + '</a>' +
        '<div class="k-drawer-upsell-card__info">' +
        '<a class="k-drawer-upsell-card__title" href="' + url + '">' + escapeHtml(product.title) + '</a>' +
        '<div class="k-drawer-upsell-card__price">' + price + '</div>' +
        '<div class="k-drawer-upsell-card__rating">' + judgeMeMini(product.id, product.title, product.handle) + '</div>' +
        '<form action="' + (routes().cartAdd || (rootRoute() + 'cart/add')) + '" method="post" data-cart-add-form><input type="hidden" name="id" value="' + variantId + '"><button type="submit">+ Add</button></form>' +
        '</div></article>');
    });
    if(html.length){
      list.innerHTML = html.join('');
      wrap.style.display = '';
      refreshJudgeMe(wrap);
    }
  }

  function renderSmartUpsells(cart){
    var el = drawer(); if(!el) return;
    var wrap = el.querySelector('[data-cart-smart-upsell]');
    if(!wrap) return;
    if(!cart || !cart.items || !cart.items.length){ wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    var ids = [];
    var used = {};
    cart.items.forEach(function(item){
      if(item.product_id && !used[item.product_id]){ used[item.product_id] = true; ids.push(item.product_id); }
    });
    if(!ids.length) return;
    var urls = ids.slice(0,3).map(function(id){
      return (routes().recommendations || (rootRoute() + 'recommendations/products.json')) + '?product_id=' + encodeURIComponent(id) + '&limit=6&intent=related';
    });
    Promise.all(urls.map(function(url){
      return fetch(url, {credentials:'same-origin', headers:{'Accept':'application/json'}})
        .then(function(res){ return res.ok ? res.json() : {products:[]}; })
        .catch(function(){ return {products:[]}; });
    })).then(function(results){
      var products = [];
      results.forEach(function(result){ (result.products || []).forEach(function(product){ products.push(product); }); });
      if(products.length) renderUpsellProducts(products, cart);
      else refreshJudgeMe(wrap);
    }).catch(function(){ refreshJudgeMe(wrap); });
  }

  function refreshCart(){
    setNotice('');
    return fetchJsonFallback(cartJsonUrls('cart'), {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(cart){ renderCart(cart); return cart; })
      .catch(function(error){ setNotice('Cart is temporarily unavailable. Please refresh and try again.'); throw error; });
  }
  function changeLine(line, quantity){
    setLoading(true);
    return fetchJsonFallback(cartJsonUrls('change'), {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:Number(line), quantity:Number(quantity)})
    }).then(function(cart){ renderCart(cart); }).catch(function(){ setNotice('Could not update your cart. Please try again.'); openDrawer(); }).finally(function(){ setLoading(false); });
  }
  function addForm(form){
    setLoading(true);
    var data = new FormData(form);
    return fetchJsonFallback(cartJsonUrls('add'), {method:'POST', credentials:'same-origin', headers:{'Accept':'application/json'}, body:data})
      .then(function(){ return refreshCart(); })
      .then(function(){ openDrawer(); })
      .catch(function(){ setNotice('Could not add this item to cart. Please try again.'); openDrawer(); })
      .finally(function(){ setLoading(false); });
  }
  document.addEventListener('click', function(event){
    var open = event.target.closest('[data-cart-open]');
    if(open){ event.preventDefault(); refreshCart().finally(openDrawer); return; }
    if(event.target.closest('[data-cart-close]')){ event.preventDefault(); closeDrawer(); return; }
    var change = event.target.closest('[data-cart-change]');
    if(change){ event.preventDefault(); changeLine(change.getAttribute('data-line'), change.getAttribute('data-quantity')); return; }
  });
  document.addEventListener('submit', function(event){
    var form = event.target;
    if(!form || !form.matches('form')) return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    var submitter = event.submitter || document.activeElement;
    var isUpsellAdd = form.hasAttribute('data-cart-add-form');
    var isNormalAtc = submitter && (submitter.hasAttribute('data-atc') || (submitter.closest && submitter.closest('[data-atc]')));
    if(isUpsellAdd || (action.indexOf('/cart/add') !== -1 && isNormalAtc)){
      event.preventDefault();
      addForm(form);
    }
  }, true);
  document.addEventListener('keydown', function(event){ if(event.key === 'Escape') closeDrawer(); });
  // v40: Do not fetch /cart.js on initial page load. The server-rendered count is enough, and the drawer refreshes when opened or after add-to-cart.
})();


// Kiddla v43: make Judge.me product-card preview badges show the real review count.
(function(){
  function showJudgeMeBadgeText(root){
    root = root || document;
    var badges = root.querySelectorAll('.product-card__judgeme.jdgm-widget, .k-judgeme-badge.jdgm-widget, .k-cart-judgeme-mini.jdgm-widget');
    badges.forEach(function(wrapper){
      var prev = wrapper.querySelector('.jdgm-prev-badge');
      if (!prev) return;

      // Judge.me stores review count in data-number-of-reviews when its metafield/script is available.
      var count = prev.getAttribute('data-number-of-reviews') || prev.getAttribute('data-number-of-reviews-value') || '';
      var text = prev.querySelector('.jdgm-prev-badge__text');

      if (text) {
        text.style.display = 'inline-block';
        text.style.visibility = 'visible';
        text.style.opacity = '1';
        var currentText = (text.textContent || '').trim();
        if ((!currentText || currentText === 'No reviews') && count && count !== '0') {
          text.textContent = count === '1' ? '1 review' : count + ' reviews';
        }
      } else if (count && count !== '0') {
        text = document.createElement('span');
        text.className = 'jdgm-prev-badge__text';
        text.textContent = count === '1' ? '1 review' : count + ' reviews';
        prev.appendChild(text);
      }
    });
  }

  window.KiddlaRefreshJudgeMeBadges = showJudgeMeBadgeText;

  function hydrateJudgeMeBadges(){
    if(window.KiddlaJudgeMeBadgeCache){ try{ document.querySelectorAll('[data-id].jdgm-preview-badge').forEach(function(node){ var id=node.getAttribute('data-id'); var html=(node.innerHTML||'').trim(); if(id && html && (html.indexOf('jdgm-prev-badge')!==-1 || html.indexOf('jdgm-star')!==-1)) window.KiddlaJudgeMeBadgeCache[String(id)] = html; }); }catch(e){} }
    showJudgeMeBadgeText(document);
    // Judge.me may hydrate badges shortly after page load, so run a few delayed passes.
    [300, 900, 1800, 3000].forEach(function(delay){
      setTimeout(function(){ showJudgeMeBadgeText(document); }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateJudgeMeBadges);
  } else {
    hydrateJudgeMeBadges();
  }
  document.addEventListener('shopify:section:load', function(event){
    setTimeout(function(){ showJudgeMeBadgeText(event.target || document); }, 150);
  });
  document.addEventListener('shopify:block:select', function(event){
    setTimeout(function(){ showJudgeMeBadgeText(event.target || document); }, 150);
  });
})();

// Kiddla v47: Move payment icons above Shopify's "More payment options" link on product pages.
(function(){
  function placeProductPaymentIcons(root){
    var scope = root || document;
    scope.querySelectorAll('.k-product-form').forEach(function(form){
      var icons = form.querySelector('.k-payment-icons--product');
      var paymentButton = form.querySelector('.k-dynamic-wrap .shopify-payment-button');
      if(!icons || !paymentButton) return;

      var moreOptions = paymentButton.querySelector('.shopify-payment-button__more-options');
      icons.classList.add('k-payment-icons--inside-dynamic');

      if(moreOptions){
        if(icons.parentNode !== paymentButton || icons.nextElementSibling !== moreOptions){
          paymentButton.insertBefore(icons, moreOptions);
        }
      } else if(icons.parentNode !== paymentButton){
        paymentButton.appendChild(icons);
      }
    });
  }

  function run(root){
    placeProductPaymentIcons(root || document);
    [250, 750, 1500, 3000].forEach(function(delay){
      setTimeout(function(){ placeProductPaymentIcons(root || document); }, delay);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }
  document.addEventListener('shopify:section:load', function(event){ run(event.target || document); });
})();

// Kiddla v48: extra-safe DOM reorder for Shopify dynamic checkout icons.
(function(){
  function reorderProductPayments(root){
    var scope = root || document;
    scope.querySelectorAll('.k-product-form').forEach(function(form){
      var icons = form.querySelector('.k-payment-icons--product');
      if(!icons) return;
      var more = form.querySelector('.shopify-payment-button__more-options');
      var button = form.querySelector('.shopify-payment-button');
      if(more && more.parentNode){
        if(icons.nextElementSibling !== more){
          more.parentNode.insertBefore(icons, more);
        }
      } else if(button && icons.parentNode !== button){
        button.appendChild(icons);
      }
    });
  }
  function run(root){
    reorderProductPayments(root || document);
    [100,300,700,1200,2200,4000].forEach(function(delay){
      setTimeout(function(){ reorderProductPayments(root || document); }, delay);
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }
  document.addEventListener('shopify:section:load', function(event){ run(event.target || document); });
})();

// Kiddla v49: final stable ordering for product payment area.
// Desired order: Buy with Shop -> accepted payment icons -> More payment options.
(function(){
  var running = false;
  function fixProductPaymentOrder(root){
    if(running) return;
    running = true;
    try{
      var scope = root || document;
      var forms = [];
      if(scope.matches && scope.matches('.k-product-form')) forms = [scope];
      else forms = Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll('.k-product-form') : []);
      forms.forEach(function(form){
        var wrap = form.querySelector('.k-dynamic-wrap');
        var payment = wrap && wrap.querySelector('.shopify-payment-button');
        var icons = form.querySelector('.k-payment-icons--product');
        if(!wrap || !payment || !icons) return;
        icons.classList.add('k-payment-icons--inside-dynamic');
        var more = payment.querySelector('.shopify-payment-button__more-options');
        if(more){
          if(icons.parentNode !== payment || icons.nextElementSibling !== more){
            payment.insertBefore(icons, more);
          }
        }else if(icons.parentNode !== payment){
          payment.appendChild(icons);
        }
        if(!payment.__kiddlaPaymentObserver){
          payment.__kiddlaPaymentObserver = true;
          var observer = new MutationObserver(function(){
            setTimeout(function(){ fixProductPaymentOrder(form); }, 0);
          });
          observer.observe(payment, {childList:true, subtree:true});
        }
      });
    }finally{
      running = false;
    }
  }
  function run(root){
    fixProductPaymentOrder(root || document);
    [80,200,500,1000,1800,3000,5000].forEach(function(delay){
      setTimeout(function(){ fixProductPaymentOrder(root || document); }, delay);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function(event){ run(event.target || document); });
  document.addEventListener('shopify:block:select', function(event){ run(event.target || document); });
})();

// Kiddla v58: wrap YouTube iframes in a responsive 16:9 container on product/page mobile views.
(function(){
  function isYoutubeIframe(el){
    if(!el || el.tagName !== 'IFRAME') return false;
    var src = (el.getAttribute('src') || '').toLowerCase();
    return src.indexOf('youtube.com') !== -1 || src.indexOf('youtube-nocookie.com') !== -1 || src.indexOf('youtu.be') !== -1;
  }
  function wrapYoutubeEmbeds(root){
    var scope = root || document;
    var frames = Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll('iframe') : []);
    frames.forEach(function(frame){
      if(!isYoutubeIframe(frame)) return;
      if(frame.closest('.k-responsive-video')) return;
      var parent = frame.parentNode;
      if(!parent) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'k-responsive-video k-youtube-embed';
      parent.insertBefore(wrapper, frame);
      wrapper.appendChild(frame);
      frame.setAttribute('loading', frame.getAttribute('loading') || 'lazy');
      frame.setAttribute('allowfullscreen', 'allowfullscreen');
      frame.removeAttribute('width');
      frame.removeAttribute('height');
    });
  }
  function run(root){
    wrapYoutubeEmbeds(root || document);
    setTimeout(function(){ wrapYoutubeEmbeds(root || document); }, 300);
    setTimeout(function(){ wrapYoutubeEmbeds(root || document); }, 1200);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  }else{
    run(document);
  }
  document.addEventListener('shopify:section:load', function(event){ run(event.target || document); });
  document.addEventListener('shopify:block:select', function(event){ run(event.target || document); });
})();
